import React, { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import IsAuth from "./helpers/isAuth";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import store from "./redux/store";
import { Provider } from "react-redux";
import AlertTemplate from "react-alert-template-basic";

export default function App() {
  const options = {
    // you can also just use 'bottom center'
    position: positions.BOTTOM_RIGHT,
    timeout: 5000,
    offset: "30px",
    // you can also just use 'scale'
    transition: transitions.SCALE
  };

  return (
    <BrowserRouter>
      <AlertProvider template={AlertTemplate} {...options}>
        <Provider store={store}>
          <IsAuth />
        </Provider>
      </AlertProvider>
    </BrowserRouter>
  );
}
